import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["email"];

  connect() {
    this.element.addEventListener("submit", (event) =>
      this.handleSubmit(event)
    );
  }

  handleSubmit(event) {
    const email = this.emailTarget?.value?.toLowerCase().trim();

    if (email && typeof window.safePosthogIdentify === "function") {
      const identified = window.safePosthogIdentify(email);
      if (!identified) return;

      event.preventDefault();
      setTimeout(() => {
        this.element.submit();
      }, 150);
    }
  }
}
